import { ReportProblem } from '@/shared-ui';
import { OptionRenderType } from '@/survey-graphql';

import ProjectResponseImageChoice from './project-response-image-choice';
import { ProjectResponseComponentProps } from './project-response-renderer.type';
import ProjectResponseSelect from './project-response-select';

const EMPTY_OPTIONS: NonNullable<ProjectResponseComponentProps['options']> = [];

export function ProjectResponseMultiSelectRendererComponent({
  id,
  app,
  text,
  options = EMPTY_OPTIONS,
  value,
  tentativeValue,
  onChange,
  readonly,
  optionRenderType,
  assets,
  maxSelections,
  audio,
  isAiVoiceEnabled,
  isFollowUp = false,
  onSubmit,
  questionId,
}: ProjectResponseComponentProps) {
  return (
    <div
      data-test='multi-select-renderer'
      className='isolate flex w-full flex-col gap-1'
    >
      {optionRenderType === OptionRenderType.Media ? (
        <ProjectResponseImageChoice
          app={app}
          options={options}
          value={value ?? ''}
          tentativeValue={tentativeValue}
          onClick={(value) => onChange?.(value)}
          readonly={readonly}
          maxSelections={maxSelections}
          assets={assets}
          text={text}
          audio={audio}
          isAiVoiceEnabled={isAiVoiceEnabled}
        />
      ) : (
        <ProjectResponseSelect
          app={app}
          onClick={(value) => onChange?.(value)}
          options={options}
          value={value ?? ''}
          tentativeValue={tentativeValue}
          readonly={readonly}
          maxSelections={maxSelections}
          assets={assets}
          text={text}
          audio={audio}
          isAiVoiceEnabled={isAiVoiceEnabled}
        />
      )}
      {onSubmit && id && (
        <ReportProblem
          context={{ messageId: id, questionId: questionId ?? undefined }}
          onSubmit={onSubmit}
          variant={isFollowUp ? 'follow-up' : 'main'}
          className='self-start'
        />
      )}
    </div>
  );
}
